<script lang="ts">
    import {markPaid} from "./stores";
    import {onMount} from "svelte";
    import {thankYouPageUrl} from "./stores";

    markPaid()

    onMount(() => {
        if ($thankYouPageUrl !== null) {
            window.location.href = $thankYouPageUrl
        }
    })
</script>

{#if $thankYouPageUrl === null}
    <div class="mt-5 text-center">
        <h4>Thank you</h4>
        <p>You will receive an email shortly to confirm your booking and you will be reminded by SMS on the day of the
            booking</p>
    </div>
{:else}
    <div class="mt-5 text-center">
        <p>Loading the thank you page...</p>
    </div>
{/if}